import Cookies from 'js-cookie'

export const persistValueToCookies = (key = '', value = '', cookieName = '', expireDate = 365) => {
  const cookieFields = Cookies.getJSON(cookieName) || {}
  cookieFields[key] = value
  if (value === '' || (typeof value === 'object' && !Object.keys(value).length)) {
    delete cookieFields[key]
  }
  Cookies.remove(cookieName)
  Cookies.set(cookieName, cookieFields, { expires: expireDate, path: '/' })
  return true
}

export const getValuesFromCookies = () => {
  const cookies = Cookies.getJSON('nft_info_request') || {}
  const fields = {}
  if (typeof cookies === 'object') {
    Object.keys(cookies).forEach(key => {
      const cleanKey = key.replace('info_request[', '').replace(']', '')
      fields[cleanKey] = cookies[key]
    })
  }
  return fields
}
